/* eslint-disable no-underscore-dangle */
import { enableProdMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MncDmePosModule as MncDmePosModule } from './app/mnc-dmepos.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

const { buildNumber, commit } = environment.version;

console.log('DMEPOS UI Version:', {
  buildNumber,
  commit,
})

platformBrowserDynamic()
  .bootstrapModule(MncDmePosModule, {
    applicationProviders: [provideZoneChangeDetection()],
    providers: [{ provide: LOCALE_ID, useValue: 'en-US' }]
  })
  .catch((err) => console.error(err));
